import React, { useEffect, useState } from "react";
import Status from "./status";

const defaultFilter = {
  activationStatus: true,
  branchType: "All"
};

const BranchFilter = (props) => {
  const [filterBranch, setFilterBranch] = useState(defaultFilter);

  const getStatus = (value) => {
    setFilterBranch(oldData => ({
      ...oldData,
      activationStatus: value
    }))
  }

  const handleSelectBranchType = (type) => {
     setFilterBranch(oldData => ({
      ...oldData,
      branchType: type
    }))
  }

  useEffect(() => {
    props.branchFilters(filterBranch)
  },[filterBranch])

  useEffect(() => {                     
    if(props.isReset){
      setFilterBranch(defaultFilter);
      props.handleResetState();
    }
  },[props.isReset])

  return(
    <div className="w-full">
      <Status getStatus={getStatus} isReset={props.isReset} handleResetState={props.handleResetState} />
      <p className="fs-16 font-weight-700 color-dark-blue m-t-20">Branch Type</p>
      <div className="d-flex-wrap m-t-10">
        <div onClick={()=>handleSelectBranchType("All")} className="d-flex m-r-20 m-b-12">
          <input className="flex-item m-r-8" type="radio" name="branch_type" style={{width:"20px", height:"20px"}} checked={filterBranch.branchType == "All"} />
          <p className="flex-item fs-16 font-weight-600">All</p>
        </div>
        <div onClick={()=>handleSelectBranchType("With Kiosk")} className="d-flex m-r-20 m-b-12">
          <input className="flex-item m-r-8" type="radio" name="branch_type" style={{width:"20px", height:"20px"}} checked={filterBranch.branchType == "With Kiosk"}/>
          <p className="flex-item fs-16 font-weight-600">With Kiosk</p>
        </div>
        <div onClick={()=>handleSelectBranchType("Without Kiosk")} className="d-flex m-b-12">
          <input className="flex-item m-r-8" type="radio" name="branch_type" style={{width:"20px", height:"20px"}} checked={filterBranch.branchType == "Without Kiosk"}/>
          <p className="flex-item fs-16 font-weight-600">Without Kiosk</p>
        </div>
      </div>
    </div>
  )
}

export default BranchFilter;